// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","FlowersCta":"FlowersCta","link":"link"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/FlowersCta/css/FlowersCta.styl
// module id = 1687
// module chunks = 0